import { GameTimer } from "./GameTimer";

interface GameStatusBadgeProps {
  status: "upcoming" | "half_time" | "done" | "live";
  kickOffDate: string;
  startDate: string;
  htStartDate: string;
}

export const GameStatusBadge = ({
  status,
  kickOffDate,
  startDate,
  htStartDate,
}: GameStatusBadgeProps) => {
  if (status === "done") {
    return (
      <div className="bg-gray-200 rounded-full px-3">
        <p className="text-sm font-extrabold text-gray-500 text-center py-2">
          Terminé
        </p>
      </div>
    );
  }

  if (status === "live") {
    return (
      <GameTimer
        startDate={htStartDate ?? startDate}
        isSecondHalfPlaying={Boolean(htStartDate)}
      />
    );
  }

  if (status === "half_time") {
    return (
      <div className="bg-gray-200 rounded-full px-3">
        <p className="text-sm font-extrabold text-gray-500 text-center py-2">
          Mi-temps
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gray-200 rounded-full px-3">
      <p className="text-sm font-extrabold text-gray-500 text-center py-2">
        {new Date(kickOffDate).toLocaleTimeString("fr-FR", {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </p>
    </div>
  );
};
